import styles from './ContentContainer.module.css';

import { Outlet, useNavigate } from 'react-router-dom';
import { React, useEffect, useState} from 'react';

import Header from "./../header/Header";
import Footer from "./../footer/Footer";
import Navbar from "./../navbar/Navbar";
import Growl from "./../growl/Growl";
import {translations} from './../i18/translations.js';


function ContentContainer() {

    //START loadContent becaouse backward compatibility
    const navigate = useNavigate();
    useEffect(() => {
        window.loadContent = (id, type) => {
            if (!type || type === 2) {
                const path = `/ContentById/${id}`;
                navigate(path);
            } else {
                console.log(`Unsupperted loadContent content type: ${type}`);
            }
        };
    }, [navigate]);
    //END loadContent because backward compatibility

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const [user, setUser] = useState(null);
    const [lang, setLang] = useState(0);
    const [message, setMessage] = useState({msg: null, type: null});

    const fetchLoggedUser = async () => {
        try {
            const response = await fetch(`${API_URL}/common/get_login_user.php`);
            const data = await response.json();
            setUser(data.user);
        } catch (error) {
            console.error("Error fetching logged user:", error);
        }
    };

    const fetchLoggedLang = async () => {
        try {
            const response = await fetch(`${API_URL}/common/get_lang.php`);
            const data = await response.json();
            setLang(data.lang);
        } catch (error) {
            console.error("Error fetching logged user:", error);
        }
    };

    useEffect(() => {
        fetchLoggedLang();
        fetchLoggedUser();
    }, []);

    const setGrowlMessage = (msg, type) => {
        setMessage({msg, type});
    };

    const showAlert = (alert) => {
        setGrowlMessage(translations[lang][alert.message], alert.type === 'alert-success' ? 'info' : 'error');
    };

    const handleUserChange = (newUser) => {
        setUser(newUser);
    };

    const handleLangChange = (newLang) => {
        setLang(newLang);
    };

    const checkAccess = (result) => {
        if (result.accessError) {
            navigate('/');
            showAlert({type: 'alert-error', message: result.accessError === 1 ? 'access_error_login' : 'access_error_access'});
            return false;
        }
        return true;
    };

    return (
            <>
            <Growl message={message} setGrowlMessage={setGrowlMessage} />
            <Header user={user} onUserChange={handleUserChange} lang={lang} onLangChange={handleLangChange} setGrowlMessage={setGrowlMessage} />
            <Navbar lang={lang} user={user} />
            
            <div className={styles['mbkegy-content-container-wrapper']}>
                <div className={styles['mbkegy-content-container']}>
                    <Outlet context={{lang, user, setUser, setGrowlMessage, showAlert, checkAccess, fetchLoggedUser}} />
                </div>
                <Footer lang={lang} />
            </div>
            
            
            </>
            );
}

export default ContentContainer;